// @ionic/core is imported, in order incorporate the ionic components in this design system
import "@ionic/core";
globalThis.Context = {};
//# sourceMappingURL=_build.global.js.map
